import React, { useState, memo } from "react";
import {
  Callout,
  Card,
  Button,
  Icon,
  Tag,
  Spinner,
  ButtonGroup,
  Dialog,
  Classes,
  HTMLTable
} from "@blueprintjs/core";

import { Trans } from "react-i18next";

import { mefDate, mefMontant, mefMontantStr } from '../../utils/mef';
import { getSetting } from '../Settings/InstallationSettings';
import EquipmentDetail from './EquipmentDetail';
import { ALPRSensorStatusTag, InfoALPRSensor } from "./ALPR/ALPRSensor";
import { CmdEquipmentOpen, LockButton, ResetButton } from './RemoteControl';
import { CameraButton } from "./Camera";
import EventFlow from './Events/EventFlow';
import { ScreenshotButton } from './Screenshot';
import { getSynthese } from './Supervision';
import Exceptions from "./Exceptions";
import { authenticatedPostFetch } from "../../utils/AuthenticatedFetch";
import DeviceSettingsButton from "./DeviceSettings/DeviceSettingsButton";

function InfoCttm(props) {
  const intent = ((props.Fin_Tk1 !== 0 && props.Fin_Tk2 !== 0)
    || (props.Liaison_OK !== 1)
    || (props.Etat_OK !== 1)) ? "danger" :
    (props.Fin_Tk1 !== 0 || props.Fin_Tk2 !== 0) ? "warning" : "success";

  if (props.Etat_OK === undefined)
    return null;
  else
    return (
      <Callout title={<span><Icon icon="full-circle" intent={intent} /> <Trans>cttm</Trans></span>}>
        {(props.Fin_Tk1 !== 0 && props.Fin_Tk2 !== 0) && <p><Tag intent="danger"><Icon icon="error" /> <Trans>no more ticket in reserve</Trans></Tag></p>}
        {(props.Liaison_OK !== 1) && <p><Tag intent="danger"><Icon icon="error" /> <Trans>cttm disconnected</Trans></Tag></p>}
        {(props.Etat_OK !== 1) && <p><Tag intent="danger"><Icon icon="error" /> <Trans>cttm ko</Trans></Tag></p>}
        <HTMLTable compact={true} striped={true} style={{ width: '100%' }}>
          <tbody>
            <tr>
              <td><Trans>ticket reserve</Trans> n°1</td>
              <td>{(props.Fin_Tk1 === 0) ? <Tag intent="success"><Icon icon="tick" /> <Trans>feeded</Trans></Tag> : <Tag intent="warning"><Icon icon="warning-sign" /> <Trans>empty</Trans></Tag>}</td>
            </tr>
            <tr>
              <td><Trans>ticket reserve</Trans> n°2</td>
              <td>{(props.Fin_Tk2 === 0) ? <Tag intent="success"><Icon icon="tick" /> <Trans>feeded</Trans></Tag> : <Tag intent="warning"><Icon icon="warning-sign" /> <Trans>empty</Trans></Tag>}</td>
            </tr>
          </tbody>
        </HTMLTable>
      </Callout >
    );
}

function InfoSas(props) {
  function state_bar_sas(state) {
    switch (state) {
      case 1: // BAR_VER
        return null;
      /* return <Tag><Trans>locked</Trans></Tag>; */
      case 3: // BAR_INT
        return <Tag><Trans>intermediate</Trans></Tag>;
      case 2: // BAR_HAU
        return <Tag><Trans>up</Trans></Tag>;
      case 4: // BAR_BAS
        return <Tag><Trans>down</Trans></Tag>;
      default:
        /* ret = <Tag>??? {state} ???</Tag>; */
        return null;
    }
  }

  if (props.enabled === undefined)
    return null;//{"enabled":false,"locked":true,"position":0}
  else
    return (
      <tr>
        <td>Sas</td>
        <td>
          {(props?.locked) ?
            <Tag
              intent="warning"
              interactive={true}
              onClick={() => authenticatedPostFetch('/device/sas/lock', {
                srv: props.srv,
                parkId: props.parkId,
                deviceId: props.deviceId,
                lock: false
              })}
            ><Icon icon="lock" /> <Trans>sas disabled</Trans></Tag>
            :
            <Tag intent="success"
              interactive={true}
              onClick={() => authenticatedPostFetch('/device/sas/lock', {
                srv: props.srv,
                parkId: props.parkId,
                deviceId: props.deviceId,
                lock: true
              })}
            ><Icon icon="unlock" /><Trans>sas active</Trans></Tag>}
          {state_bar_sas(props.position)}
        </td>
      </tr>
    );
}

function InfoRecycler(props) {
  if (!getSetting("display financial data in supervision", true))
    return null;
  if (props.recycler === undefined) {
    return <td></td>;
  } else {
    var intent;
    switch (props.recycler.Monnaie) {
      case 0:
        intent = "danger"; // PLEIN
        break;
      case 1:
        intent = "danger"; // VIDE
        break;
      case 2:
        intent = "warning"; // PRESQUE_VIDE
        break;
      case 3:
        intent = "success"; // NORMAL
        break;
      case 4:
        intent = "warning"; // PRESQUE_PLEIN
        break;
      default:
        intent = "";
    }
    return (
      <tr>
        <td><Icon icon="full-circle" intent={intent} /></td>
        {/* <td>{JSON.stringify(props.recycler.Etat)}</td> */}
        <td>{mefMontant(JSON.stringify(props.recycler.Val_Piece))}</td>
        {/* <td>{JSON.stringify(props.recycler.Monnaie)}</td> */}
        <td>{JSON.stringify(props.recycler.Nb_Pieces)}</td>
        <td>{mefMontant(JSON.stringify(props.recycler.Val_Piece * props.recycler.Nb_Pieces))}</td>
      </tr>
    );
  }
}

function InfoRecyclers(props) {
  const [isOpen, open] = useState(false);

  if (getSetting("display financial data in supervision", true)) {
    var ret = [];
    let icon = null;
    let state = 0;
    if (props.recyclers !== undefined && Array.isArray(props.recyclers)) {
      for (const r of props.recyclers) {
        ret.push(<InfoRecycler key={r.Val_Piece} recycler={r} />);
        state = r.Etat > state ? r.Etat : state;
      }
      switch (state) {
        case 0: // SM_OK (mais HS ?)
          icon = <Icon icon="full-circle" intent="success" />
          break;
        case 1: // SM_KO (mais warning ?)
          icon = <Icon icon="full-circle" intent="warning" />
          break;
        case 2: // SM_ABSENT
          icon = <Icon icon="full-circle" intent="danger" />
          break;
        default:
          break;
      }
    }

    return ([
      <tr>
        <td><Trans>coin recyclers</Trans></td>
        <td>
          <span>{icon} <Button onClick={() => open(!isOpen)}>
            {isOpen ? <Trans>hide</Trans> : <Trans>show</Trans>} <Trans>detail</Trans>
          </Button></span>
        </td>
      </tr>,
      isOpen && <tr>
        <td colspan="2">
          <HTMLTable compact={true} striped={true} style={{ width: '100%' }}>
            <thead>
              <tr>
                <th>{/* circle */}</th>
                <th><Trans>value</Trans></th>
                <th><Trans>number of coins</Trans></th>
                <th><Trans>amount</Trans></th>
              </tr>
            </thead>
            <tbody>
              {ret}
            </tbody>
          </HTMLTable>
        </td>
      </tr>
    ]);
  }
  else
    return false
}

/* SM_OK 		= 0,		// RBN : il faut definir les valeurs en fonction des messages reseau
  SM_KO 		= 1,
  SM_ABSENT 	= 2 */

function InfoHoopers(props) {
  const [isOpen, open] = useState(false);
  const ret = [];
  let state = 0;
  let icon;

  for (const hooper of props.hoopers) {
    ret.push(<InfoRecycler key={"hooper" + hooper.Val_Piece} recycler={hooper} />);
    state = hooper.State > state ? hooper.State : state;
  }

  switch (state) {
    case 0: icon = <Icon icon="full-circle" intent="success" />; break;
    case 1: icon = <span><Icon icon="full-circle" intent="danger" /><Trans>out of order</Trans></span>; break;
    case 2: default: icon = <span><Icon icon="full-circle" intent="danger" /><Trans>absent</Trans></span>; break;
  }

  return props.hoopers.length > 0 ? [
    <tr>
      <td><Trans>coin hoopers</Trans></td>
      <td>
        <span>{icon} <Button onClick={() => open(!isOpen)}>
          {isOpen ? <Trans>hide</Trans> : <Trans>show</Trans>} <Trans>detail</Trans>
        </Button></span>
      </td>
    </tr>,
    isOpen && <tr>
      <td colspan="2">
        <HTMLTable compact={true} striped={true} style={{ width: '100%' }}>
          <thead>
            <tr>
              <th>{/* circle */}</th>
              <th><Trans>value</Trans></th>
              <th><Trans>number of coins</Trans></th>
              <th><Trans>amount</Trans></th>
            </tr>
          </thead>
          <tbody>
            {ret}
          </tbody>
        </HTMLTable>
      </td>
    </tr>
  ]
    : null;
}

function InfoCoins(props) {
  if (!getSetting("display financial data in supervision", true))
    return null;

  if (props.coin_acceptor !== undefined && props.coin_acceptor.Etat_OK !== undefined) {
    var icon;
    switch (props.coin_acceptor.Etat_OK) {
      case 0: // SM_OK (mais HS ?)
        icon = <Icon icon="full-circle" intent="danger" />
        break;
      case 1: // SM_KO (mais warning ?)
        icon = <Icon icon="full-circle" intent="warning" />
        break;
      case 2: // SM_ABSENT (mais OK ?)
        icon = <Icon icon="full-circle" intent="success" />
        break;
      default:
        break;
    }
    return (<Callout title={<span>{icon} <Trans>coin acceptor</Trans></span>}>
      {(props.coin_acceptor.Etat_OK === 0) && <Tag intent="danger"><Icon icon="warning-sign" /> <Trans>monnayeur hs</Trans></Tag>}
      <HTMLTable compact={true} striped={true} style={{ width: '100%' }}>
        <tbody>
          <tr>
            <td><Trans>coin renderer state</Trans></td>
            <td>{(props.coin_acceptor.Manque_Monnaie !== 0) ? <Tag intent="warning"><Icon icon="warning-sign" /> <Trans>manque monnaie</Trans></Tag> : <Tag intent="success"><Icon icon="tick" /> <Trans>monnaie dispo</Trans></Tag>}</td>
          </tr>
          <tr>
            <td><Trans>value in coin box</Trans></td>
            <td>{mefMontantStr(props.coin_acceptor.caisse.Montant)}</td>
          </tr>
          <tr>
            <td><Trans>number of coins in the coin box</Trans></td>
            <td>{props.coin_acceptor.caisse.Nb_Pieces}</td>
          </tr>
          <tr>
            <td><Trans>last transaction</Trans></td>
            <td>{mefMontantStr(JSON.stringify(props.coin_acceptor.Dern_Trans))}</td>
          </tr>
          <InfoHoopers hoopers={props.coin_acceptor.reserves} />
          <InfoRecyclers recyclers={props.coin_acceptor.recyclers} />
        </tbody>
      </HTMLTable>



      {/* <InfoCaisse caisse={props.coin_acceptor.caisse} /> */}
    </Callout >);
  }
  else return null;
}

function InfoBill(props) {
  if (!getSetting("display financial data in supervision", true))
    return null;
  return (
    <tr>
      <td>{mefMontant(props.bill.Val_Billet, props.bill.Devise)}</td>
      <td>{props.bill.Nb_Billets}</td>
      <td>{mefMontant(props.bill.Val_Billet * props.bill.Nb_Billets, props.bill.Devise)}</td>
    </tr>
  );
}

class InfoBills extends React.Component {
  state = {
    isOpen: false,
    isOpenRecycler: false
  };

  state_monnaie(state) {
    switch (state) {
      case 0: //PLEIN
        return <Tag intent="danger"><Icon icon="error" />  <Trans>full</Trans></Tag>;
      case 1: //VIDE
        return <Tag intent="danger"><Icon icon="error" />  <Trans>empty</Trans></Tag>;
      case 2: //PRESQUE_VIDE (not used for bills)
        return <Tag intent="warning"><Icon icon="error" />  <Trans>almost empty</Trans></Tag>;
      case 3: //NORMAL
        return <Tag intent="success"><Icon icon="tick" /> Normal</Tag>;
      case 4: //PRESQUE_PLEIN (not used for bills)
        return <Tag intent="warning"><Icon icon="error" />  <Trans>almost full</Trans></Tag>;
      default:
        return null;
    }
  }

  render() {
    if (!getSetting("display financial data in supervision", true))
      return null;

    if (this.props.bill_acceptor === undefined)
      return null;

    var bills = [];
    let id=0
    if (Array.isArray(this.props.bill_acceptor.bills)) {
      for (const b of this.props.bill_acceptor.bills)
        bills.push(<InfoBill key={"b" + b.Val_Billet} bill={b} id={id++}/>);
    }

    var recyclers = [];
    if (Array.isArray(this.props.bill_acceptor.recyclers)) {
      for (const b of this.props.bill_acceptor.recyclers)
        recyclers.push(<InfoBill key={"br" + b.Val_Billet} bill={b} />);
    }

    var icon;
    switch (this.props.bill_acceptor.Etat_OK) {
      case 0: // NON
        icon = <Icon icon="full-circle" intent="danger" />;
        break;
      case 1: // OUI
        icon = <Icon icon="full-circle" intent="success" />;
        break;
      case 2: // NIOUI_NINON
        icon = <Icon icon="full-circle" intent="warning" />;
        break;
      default:
        break;
    }

    return (
      <Callout title={<span>{icon} <Trans>bill acceptor</Trans></span>}>
        <HTMLTable compact={true} striped={true} style={{ width: '100%' }}>
          <tbody>
            <tr>
              <td><Trans>bill box presence</Trans></td>
              <td>{(this.props.bill_acceptor.Coffre_Present === 1) ? <Tag intent="success"><Icon icon="tick" /> <Trans>present</Trans></Tag> : <Tag intent="danger"><Icon icon="error" />Absent</Tag>}</td>
            </tr>
            <tr>
              <td><Trans>bill recycler</Trans></td>
              <td>{recyclers.length > 0 ? 
                <>
                  <Tag intent="success"><Icon icon="tick" /> <Trans>present</Trans></Tag>{" "}
                  <Button onClick={()=>this.setState({isOpenRecycler: !this.state.isOpenRecycler})}>
                  {this.state.isOpenRecycler ? <Trans>hide</Trans> : <Trans>show</Trans>} <Trans>detail</Trans>
                  </Button>
                  <HTMLTable compact={true} striped={true} style={{ width: '100%' }} hidden={!this.state.isOpenRecycler}>
                    <thead>
                      <tr>
                        <th><Trans>value</Trans></th>
                        <th><Trans>number of bills</Trans></th>
                        <th><Trans>amount</Trans></th>
                      </tr>
                    </thead>
                    <tbody>
                      {recyclers}
                    </tbody>
                  </HTMLTable>
                </> : <Tag><Icon icon="error" /> Absent</Tag>}
              </td>
            </tr>
            <tr>
              <td><Trans>bill box state</Trans></td>
              <td>{this.state_monnaie(this.props.bill_acceptor.Monnaie)} <Button onClick={()=>this.setState({isOpen: !this.state.isOpen})}>
                {this.state.isOpen ? <Trans>hide</Trans> : <Trans>show</Trans>} <Trans>detail</Trans>
              </Button>
                <HTMLTable compact={true} striped={true} style={{ width: '100%' }} hidden={!this.state.isOpen}>
                  <thead>
                    <tr>
                      <th><Trans>value</Trans></th>
                      <th><Trans>number of bills</Trans></th>
                      <th><Trans>amount</Trans></th>
                    </tr>
                  </thead>
                  <tbody>
                    {bills}
                  </tbody>
                </HTMLTable>
              </td>
            </tr>
          </tbody>
        </HTMLTable>
      </Callout >
    );
  }
}

function InfoET(props) {
  function state_bar(state) {
    switch (state) {
      case 0: // HAUTE
        return <tr><td><Trans>barrier position</Trans></td><td><Tag><Trans>up</Trans></Tag></td></tr>;
      case 1: // BASSE
        return <tr><td><Trans>barrier position</Trans></td><td><Tag><Trans>down</Trans></Tag></td></tr>;
      case 2: // INTERMEDIAIRE
        return <tr><td><Trans>barrier position</Trans></td><td><Tag><Trans>intermediate</Trans></Tag></td></tr>;
      default:
        return null;
    }
  }

  function state_presence(state) {
    switch (state) {
      case 0:
        return <tr><td><Trans>presence</Trans></td><td><Tag><Icon icon="cross" /> <Trans>no detected vehicle</Trans></Tag></td></tr>;
      case 1:
        return <tr><td><Trans>presence</Trans></td><td><Tag><Icon icon="known-vehicle" /> <Trans>detected vehicle</Trans></Tag></td></tr>;
      default:
        return null;
    }
  }

  function state_pompier(state) {
    switch (state) {
      case 1: // Verrou POMPIER
        return <p><Trans>lock</Trans> : <Tag intent="danger"><Icon icon="flame" /> <Trans>pompier</Trans></Tag></p>;
      case 2: // Verrou EXTERNE
        return <p><Trans>lock</Trans> : <Tag intent="danger"><Icon icon="lock" /> <Trans>external</Trans></Tag></p>;
      case 3: // Verrou POMPIER+EXTERNE
        return <p><Trans>lock</Trans> : <Tag intent="danger"><Icon icon="flame" /> <Trans>pompier</Trans> + <Trans>external</Trans></Tag></p>;
      default: // including 0 = Pas de verrou
        return null;
    }
  }

  function degondage(state) {
    return (state !== 0) && <p><Tag intent="danger"><Icon icon="error" /> <Trans>dégondage barrière</Trans></Tag ></p>;
  }

  function electrical_default(state) {
    return (state !== 0) && <p><Tag intent="danger"><Icon icon="error" /> <Trans>défaut electrique</Trans></Tag ></p>;
  }

  function effraction(state) {
    return (state !== 0) && <p><Tag intent="danger"><Icon icon="error" /> <Trans>door open</Trans></Tag ></p>;
  }

  if (props.borne !== undefined)
    return (
      <Callout>
        {(props.borne?.DefautCB) && <Tag intent="danger"><Icon icon="error" /> <Trans>contactless card reader is out of order</Trans></Tag>}
        {(props.borne?.DefautCSC) && <Tag intent="danger"><Icon icon="error" /> <Trans>credit card terminal is out of order</Trans></Tag>}
        {effraction(props.borne.Effr_Basse)}
        {electrical_default(props.borne.Bar_Def_Elec)}
        {state_pompier(props.borne.Verrou_Pompier)}
        <Callout title={<Trans>barrier</Trans>}>
          {degondage(props.borne.Bar_Degondee)}
          <HTMLTable striped={true} compact={true}>
            <tbody>
              {state_presence(props.borne.Presence)}
              {state_bar(props.borne.Bar_Pos)}
              <InfoSas {...props.borne.sas} srv={props.srv} parkId={props.parkId} deviceId={props.deviceId} />
            </tbody>
          </HTMLTable>
        </Callout>
        <InfoCttm {...props.borne.cttm} />
      </Callout>
    );
  else
    return null;
}

function InfoPS(props) {
  const intervention = [];

  if (props.ps !== undefined) {
    if (props.ps.Intervention === 1)
      intervention.push(<Tag intent="danger" icon="wrench"><Trans>intervention in progress by user</Trans> n°{props.ps.Code_Util}</Tag>);

    return (
      <Callout>
        {(props.ps?.DefautCB) && <Tag intent="danger"><Icon icon="error" /> <Trans>contactless card reader is out of order</Trans></Tag>}
        {(props.ps?.DefautCSC) && <Tag intent="danger"><Icon icon="error" /> <Trans>credit card terminal is out of order</Trans></Tag>}
        {(props.ps.Ouv_Porte !== 0) && <Tag intent="danger"><Icon icon="error" /> <Trans>door open</Trans></Tag>}
        {(props.ps.Effr_Exter !== 0) && <Tag intent="danger"><Icon icon="error" /> <Trans>Effr_Exter</Trans></Tag>}
        {(props.ps.Pres_Sect !== 1) && <Tag intent="danger"><Icon icon="error" /> <Trans>Pres_Sect</Trans></Tag>}
        {intervention}
        <InfoCoins coin_acceptor={props.ps.coin_acceptor} />
        <InfoBills bill_acceptor={props.ps.bill_acceptor} />
        <InfoCttm {...props.ps.cttm} />
      </Callout>
    );
  }
  else
    return null;
}

function InfoSession(props) {
  switch (props.state) {
    case 0:
      return <Callout title={<span><Icon icon="full-circle" intent="success" /> Session</span>}>
        <Trans>session opened</Trans> <Trans>by user</Trans> <Tag intent="primary" icon="person">{props.user}</Tag> <Trans>since</Trans> {mefDate(props.since)}
      </Callout>
    case 1:
      return <Callout title={<span><Icon icon="full-circle" intent="danger" /> Session</span>}>
        <Trans>session closed</Trans>
      </Callout>
    case 2:
      return <Callout title={<span><Icon icon="full-circle" intent="warning" /> Session</span>}>
        <Trans>session suspended</Trans> <Trans>by user</Trans> <Tag intent="primary" icon="person">{props.user}</Tag>
      </Callout>
    default:
      return null;
  }
}

function InfoCM(props) {
  if (props.cm !== undefined) {
    return (
      <Callout>
        <InfoSession {...props.cm.session} />
        {props.cm.Manque_Tk && <Tag intent="danger"><Icon icon="error" /> <Trans><Trans>no more ticket in reserve</Trans></Trans></Tag>}
        <InfoCttm {...props.cm.cttm} />
      </Callout>
    );
  }
  return null;
}

function InfoLP(props) {
  if (props.lp !== undefined) {
    return (
      <Callout>
        {(props.borne?.DefautCB) && <Tag intent="danger"><Icon icon="error" /> <Trans>contactless card reader is out of order</Trans></Tag>}
        {(props.borne?.DefautCSC) && <Tag intent="danger"><Icon icon="error" /> <Trans>credit card terminal is out of order</Trans></Tag>}
      </Callout>
    );
  }
  return null;
}

export function GeneralInfo(props) {
  if (props.info !== undefined) {
    var intent;
    switch (props.synthese) {
      case 0: // ST_OK
        intent = "success";// "primary" ?
        break;
      case 1: // ST_KO
        intent = "danger";
        break;
      case 2: // ST_DEF
        intent = "warning";
        break;
      default: // ST_LIAISON or ST_INCONNU
        intent = "";
    }
    return (
      <Tag large={true} intent={intent} fill={true}>
        <div className="flexbox-center noselect"><b>{props.info.lbl}</b>
          {(props.size > 0.7) && <span><Trans>park</Trans> n°{props.info.parc} <Trans>{props.info.type}</Trans> n°{props.info.id}</span>}
        </div>
      </Tag>
    );
  } else
    return null;
}

export class ImageStatus extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      bonhommeType: "",
      imgCar: Math.floor(Math.random() * 2) + 1,
      firstAnimatedDisplay: true
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.displayAnimations && this.props.displayAnimations !== prevProps.displayAnimations)
      this.setState({ firstAnimatedDisplay: true });
    else if (this.state.firstAnimatedDisplay === true)
      this.setState({ firstAnimatedDisplay: false });
  }

  render() {
    const size = (this.props.imgScale !== undefined && this.props.imgScale > 0 && this.props.imgScale < 5) ? this.props.imgScale : 0.5;
    const animationEnabled = (this.props.displayAnimations !== undefined) ? this.props.displayAnimations : true;
    if (this.props?.eq?.general?.generation === "400") {
      switch (this.props.eq.general.type) {
        case "E":
        case "S":
          if ((this.props.eq.general.connected !== undefined && !this.props.eq.general.connected))
            return <div className="flexbox-center" style={{ width: 300 * size }}>
              <img src="/ow/view/pictures/equipments/400/BES_HS.webp" alt="borne presence fermée" style={{ height: 200 * size }} className="noselect" />
            </div>;
          else {
            return (
              <div style={{ overflow: "hidden", width: 300 * size }}>
                <div style={{ overflow: "hidden", width: 500 * size }}>
                  <img
                    src={"/ow/view/pictures/car" + this.state.imgCar + ".webp"}
                    alt="Car"
                    className={((this.props.eq?.bo?.Presence !== undefined && this.props.eq?.bo?.Presence === 1) ? "carPresent" : "carAbsent") + (animationEnabled ? "Animated" : "")}
                    style={(this.props.eq?.bo?.Presence !== undefined && this.props.eq?.bo?.Presence === 1) ? { height: 200 * size, marginLeft: -150 * size, left: 50 * size, animationIterationCount: this.state.firstAnimatedDisplay ? 0 : 1 } : { height: 200 * size, marginLeft: -150 * size, left: 1000 * size, top: 100 * size, animationIterationCount: this.state.firstAnimatedDisplay ? 0 : 1 }}
                  />
                  <img
                    src={(this.props.eq.general.synthese !== undefined && this.props.eq.general.synthese === 1) ? "/ow/view/pictures/equipments/400/BES_HS.webp" : "/ow/view/pictures/equipments/400/BES_ES.webp"}
                    alt="borne presence fermée"
                    style={{ height: 200 * size }}
                  />
                  <img src="/ow/view/pictures/barrier.webp"
                    alt="barrier"
                    className={((this.props.eq?.bo?.Bar_Pos !== undefined && this.props.eq?.bo?.Bar_Pos !== 0) ? "barrierClosed" : "barrierOpen") + (animationEnabled ? "Animated" : "")}
                    style={{ position: "relative", right: 200 * size, bottom: 100 * size, height: 44 * size, animationIterationCount: this.state.firstAnimatedDisplay ? 0 : 1 }}
                  />
                </div>
              </div>
            );
          }
        case "C":
          if ((this.props.eq.general.synthese !== undefined && this.props.eq.general.synthese === 1) || (this.props.eq.general.connected !== undefined && !this.props.eq.general.connected)) {
            return <div className="flexbox-center" style={{ width: 300 * size }}>
              <img src="/ow/view/pictures/equipments/400/CA_HS.webp" alt="caisse automatique HS" style={{ height: 200 * size }} />
            </div>;
          }
          else {
            let bonhommeType = "";
            if (this.props.eq.ca.Paiement === 1)
              bonhommeType = "user"
            else if (this.props.eq.ca.Intervention === 1)
              bonhommeType = "worker"

            return <div style={{ overflow: "hidden", width: 300 * size }}>
              <div style={{ overflow: "hidden", width: 500 * size }}>
                <img
                  src={(bonhommeType === "worker") ? "/ow/view/pictures/worker.svg" : "/ow/view/pictures/user.svg"}
                  alt="user"
                  style={{ height: 150 * size, animationIterationCount: this.state.firstAnimatedDisplay ? 0 : 1 }}
                  className={(((this.props.eq.ca.Paiement !== undefined && this.props.eq.ca.Paiement === 1) || (this.props.eq.ca.Intervention !== undefined && this.props.eq.ca.Intervention === 1)) ? "userPresent" : "userAbsent") + (animationEnabled ? "Animated" : "")}
                />
                <img
                  src="/ow/view/pictures/equipments/400/CA_ES.webp"
                  alt="caisse automatique"
                  style={{ height: 200 * size, animationIterationCount: this.state.firstAnimatedDisplay ? 0 : 1 }}
                />
              </div>
            </div>;
          }
        case "L":
        case "l":
        case "e":
        case "s":
          if ((this.props.eq.general.lock !== 0) || (this.props.eq.general.connected !== undefined && !this.props.eq.general.connected))
            return <div className="flexbox-center" style={{ width: 300 * size }}>
              <img src="/ow/view/pictures/equipments/400/LP_HS.webp" alt="lecteur piéton HS" style={{ height: 200 * size }} />
            </div>;
          else
            return <div className="flexbox-center" style={{ width: 300 * size }}>
              <img src="/ow/view/pictures/equipments/400/LP_ES.webp" alt="lecteur piéton" style={{ height: 200 * size }} />
            </div>;
        default:
          break;
      }
    }

    if (this.props?.eq?.bo !== undefined) {
      if (this.props.eq.bo?.Presence !== undefined && this.props.eq.bo?.Presence === 1) {
        if (this.props.eq.bo?.Bar_Pos !== undefined && this.props.eq.bo?.Bar_Pos === 1)
          return <img src="/ow/view/pictures/equipments/300/B4.webp" alt="borne presence fermée" style={{ height: 200 * size }} />;
        else
          return <img src="/ow/view/pictures/equipments/300/B3.webp" alt="borne presence ouverte" style={{ height: 200 * size }} />;
      }
      else {
        if (this.props.eq.bo?.Bar_Pos !== undefined && this.props.eq.bo?.Bar_Pos === 1)
          return <img src="/ow/view/pictures/equipments/300/B2.webp" alt="borne sans presence fermée" style={{ height: 200 * size }} />;
        else
          return <img src="/ow/view/pictures/equipments/300/B1.webp" alt="borne sans presence ouverte" style={{ height: 200 * size }} />;
      }
    }
    else if (this.props?.eq?.ca !== undefined) {
      if (this.props.eq.ca.Intervention !== undefined && this.props.eq.ca.Intervention === 1)
        return <img src="/ow/view/pictures/equipments/300/CI.webp" alt="caisse" style={{ height: 200 * size }} />;
      else if (this.props.eq.ca.Paiement !== undefined && this.props.eq.ca.Paiement === 1)
        return <img src="/ow/view/pictures/equipments/300/CP.webp" alt="caisse" style={{ height: 200 * size }} />;
      else
        return <img src="/ow/view/pictures/equipments/300/C.webp" alt="caisse" style={{ height: 200 * size }} />;
    }
    else if (["L", "l", "p", "e", "s"].includes(this.props?.eq?.general?.type)) {
      if (this.props.eq.general.lock !== 0)
        return <img src="/ow/view/pictures/equipments/300/P_R.webp" alt="LP HS" style={{ height: 200 * size }} />;
      else
        return <img src="/ow/view/pictures/equipments/300/P_V.webp" alt="LP ES" style={{ height: 200 * size }} />;
    }
    else if (this.props?.eq?.general?.type === "K") {
      return <img src="/ow/view/pictures/equipments/300/K_G.webp" alt="CM OK" style={{ height: 200 * size }} />;
    }
    else
      return <img src="/ow/view/pictures/equipments/300/B0.webp" alt="unknown" style={{ height: 200 * size }} />;
  }
}
       
export const Equipment = memo((props) => { // memo prevent rerendering of all equipments when props of the parent change (compare the value of the props instead of the ref)
  const [isDetailOpen, setIsDetailOpen] = useState(false);
  var synthese = 0;

  if (props.eq !== undefined) {
    synthese = getSynthese(props.eq);
    const ret = [];
    ret.push(<GeneralInfo size={props.imgScale} key={"infoG"} info={props.eq.general} synthese={synthese} />);
    if (props.extended) {
      ret.push(<InfoET key="infoet" borne={props.eq.bo} srv={props.eq.general.server} parkId={props.eq.general.parc} deviceId={props.eq.general.id} />);
      ret.push(<InfoPS key="infops" ps={props.eq.ca} />);
      ret.push(<InfoCM key="infocm" cm={props.eq.cm} />);
      ret.push(<InfoLP key="infolp" lp={props.eq.lp} />);
      ret.push(<InfoALPRSensor key="infoalpr" {...props.ALPR_sensor} />);
    }

    const btnGroup = [];

    if (props.extended === true && ["L", "l", "p", "E", "S"].includes(props.eq.general.type))
      btnGroup.push(<CmdEquipmentOpen key="ce" neq={props.eq.general.id} npk={props.eq.general.parc} srv={props.eq.general.server} />);

    if ((props.eq.general.camera !== undefined && props.eq.general.camera === true) || getSetting("mode demo", false))
      btnGroup.push(<CameraButton key="cam" label={props.eq.general.lbl} eq={props.eq.general.id} srv={props.eq.general.server}/>);

    if (props.eq.general.GUI !== undefined && props.eq.general.GUI !== "unknown")
      btnGroup.push(<ScreenshotButton key="sc" label={props.eq.general.lbl} eq={props.eq.general.id} srv={props.eq.general.server} />);

    btnGroup.push(<LockButton key="lb" equipment={props.eq} srv={props.eq.general.server} />);

    if (getSetting("display device reset button", false) && props.extended)
      btnGroup.push(<ResetButton key="rb" equipment={props.eq} srv={props.eq.general.server} />);

    ret.push(<div key="cmd" className="flexbox-center-center">
      <ButtonGroup vertical={(props.displayImages === undefined || props.displayImages === true)}>
        {btnGroup}
      </ButtonGroup>
      {(props.displayImages !== false) &&
        <div className="noselect" >
          <ImageStatus eq={props.eq} imgScale={props.imgScale} displayAnimations={props.displayAnimations} />
        </div>
      }
    </div >);

    if (props.extended) {
      ret.push(
      <div className="flexbox-center-large" key="miniinfo">
        <DeviceSettingsButton {...props.eq} />
        <div>
          <p className="quietinfo">updated on {props.eq.last_update}</p>
          <p className="quietinfo">version: {props.eq.general.software}</p>
        </div>
      </div>);

      ret.push(<EventFlow
        key="ef"
        equipment={props.eq.general.id}
        srv={props.eq.general.server}
        static={false}
        position="bottom"
      />);
    }
    else
      ret.push(
        <div className="flexbox-center" key="ed">
          {props.ALPR_sensor && <ALPRSensorStatusTag {...props.ALPR_sensor.state} />}
        </div>);

    return (
      <Card
        id={props.id}
        key={"eq" + props.eq.general.id + "_" + props.eq.general.server}
        className="myCard"
        elevation={props.selected ? 4 : 0}
        style={{ border: props.selected ? "1px solid grey" : "" }}
      >
        <EquipmentDetail
          extended={props.extended}
          equipment={props.eq}
          text={<Trans>show details</Trans>}
          ALPR_sensor={props.ALPR_sensor}
        >
          {ret}
          {isDetailOpen && (
            <Dialog
              isOpen={isDetailOpen}
              canEscapeKeyClose={true}
              canOutsideClickClose={true}
              onClose={() => {
                setIsDetailOpen(!isDetailOpen);
              }}
            >
              <div className={Classes.DIALOG_BODY}>
                <Equipment
                  eq={props.eq}
                  extended={true}
                  imgScale={props.imgScale}
                  displayAnimations={props.displayAnimations}
                />
                {(props.eq.general.synthese === 0 ||
                  props.eq.general.synthese === 2) &&
                (props.eq.general.type === "S" ||
                  props.eq.general.type === "C") ? (
                  <Exceptions eq={props.eq} />
                ) : null}
              </div>
            </Dialog>
          )}
        </EquipmentDetail>
      </Card>
    );
  } else
    return (<Spinner />);
});
